import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.confirmIdeal.title',
    defaultMessage: 'Confirm recurring payments',
    description: 'title of the confirm recurring payments page',
  },
  paymentFailed: {
    title: {
      id: 'pages.confirmIdeal.paymentFailed.title',
      defaultMessage: 'Payment failed',
      description: 'title of the payment failed card',
    },
    description: {
      id: 'pages.confirmIdeal.paymentFailed.description',
      defaultMessage:
        'The requested payment has failed, please try again with the same or a different bank.',
      description: 'description of the payment failed card',
    },
  },
  actions: {
    retry: {
      id: 'actions.retry',
      defaultMessage: 'retry',
      description: 'label of the retry button',
    },
    cancel: {
      id: 'actions.cancel',
      defaultMessage: 'cancel',
      description: 'label of the cancel button',
    },
  },
};

export default defineMessages(translations);
